<template>
	<div class="form mx-auto">
		<slot name="header">
			<h4 class="mb-4">Share Report</h4>
		</slot>

		<tags-input
			v-model="models.members"
			:max="5"
			@input="onSearch"
			@change="searchQuery = ''"
			rules="required|email"
			tag-size="mini"
			:tag-only="'Superuser' === $user.get().role"
			type="email"
			placeholder="Add email"
		></tags-input>

		<b-form @submit.prevent="submitForm">
			<p v-if="maxReached" class="mt-3 mb-0 small">
				<b-icon-info-circle class="mr-1"></b-icon-info-circle> Maximum
				number of email addresses reached.
			</p>
			<template v-else>
				<b-overlay
					:show="formFetching"
					variant="white"
					opacity="1"
					no-fade
				>
					<template #overlay>
						<b-icon
							icon="three-dots"
							animation="cylon"
							variant="primary"
							scale="2"
							shift-v="8"
							shift-h="8"
							class="position-absolute"
						></b-icon>
					</template>

					<div
						v-if="memberOptions.length"
						class="mt-3 overflow-auto members"
					>
						<b-form-checkbox
							@change="selectAll"
							:checked="allSelected"
							class="text-capitalize"
							>All Users</b-form-checkbox
						>

						<b-form-group>
							<b-form-checkbox-group
								v-model="models.members"
								stacked
							>
								<b-form-checkbox
									v-for="member in memberOptions"
									:key="member.id"
									:value="member.email"
									>{{ member.name }}</b-form-checkbox
								>
							</b-form-checkbox-group>
						</b-form-group>
					</div>
					<p v-else class="mt-3 mb-0 small">No members found.</p>
				</b-overlay>
			</template>

			<div class="mt-4 d-flex justify-content-between">
				<slot name="return"></slot>
				<slot name="submit">
					<base-button
						:disabled="!submittable"
						:loading="formProcessing"
						type="primary"
						native-type="submit"
						size="md"
						class="form-btn font-weight-normal"
						>Share</base-button
					>
				</slot>
			</div>
		</b-form>
	</div>
</template>

<script>
import { debounce, get, orderBy } from "lodash-es";
import Fuse from "fuse.js";

import TagsInput from "@components/Inputs/TagsInput";

export default {
	name: "form-share-report",
	inject: ["memberSvc", "reportSvc"],
	props: {
		reportId: {
			type: Number,
			required: true,
		},
	},
	components: {
		[TagsInput.name]: TagsInput,
	},
	data() {
		return {
			formProcessing: false,
			formFetching: true,
			searchQuery: "",
			membersList: [],
			models: {
				members: [],
			},
		};
	},
	computed: {
		maxReached() {
			return 5 <= this.models.members.length;
		},
		allSelected() {
			const options = this.memberOptions.map((item) => item.email);
			const selected = this.models.members.filter((item) => {
				return 0 <= options.indexOf(item);
			});

			return options.length == selected.length;
		},
		memberOptions() {
			var members = this.membersList;
			const fuse = new Fuse(members, {
				keys: ["name", "email"],
				includeScore: true,
				useExtendedSearch: true,
				threshold: 0.3,
			});

			if ("" !== this.searchQuery)
				members = fuse
					.search(`'${this.searchQuery}`)
					.map((item) => item.item);

			members = members.map((item) => {
				return {
					id: item.id,
					email: item.email,
					name: item.name,
				};
			});

			return 0 < members.length
				? orderBy(members, [(item) => get(item, "name").toLowerCase()])
				: [];
		},
		submittable() {
			return 0 < this.models.members.length;
		},
	},
	watch: {
		formProcessing: function (val) {
			this.$emitter.on("share-report-form-processing", val);
		},
	},
	methods: {
		selectAll() {
			this.models.members =
				this.memberOptions.length == this.models.members.length
					? []
					: this.memberOptions.slice(0, 5).map((item) => item.email);
		},
		onSearch: debounce(function (keyword) {
			this.searchQuery = keyword;
		}, 500),
		async fetchMembers() {
			const response = await this.memberSvc.listWithAssignedReports(
				{
					page_size: 1000,
					company_id: !this.$user.get().is_superuser
						? this.$user.get().company
							? this.$user.get().company.id
							: null
						: null,
				},
				false
			);

			this.formFetching = false;
			this.membersList = response.data.data.data.members.results;
		},
		async submitForm() {
			this.formProcessing = true;

			await this.reportSvc.share({
				email: this.models.members.join(","),
				report_id: this.reportId,
			});

			this.$toasted.show("Report shared succesfully.");

			this.reset();
			this.fetchMembers();
		},
		reset() {
			Object.assign(this.$data, this.$options.data.apply(this));
		},
	},
	mounted() {
		this.fetchMembers();
	},
	beforeDestroy() {
		this.reset();
	},
};
</script>

<style lang="scss">
.members {
	max-height: 200px;

	.custom-control {
		margin-bottom: 0.5rem;
	}
}

#user-form {
	.row {
		flex-direction: row;

		.col {
			flex: 0 0 auto;
		}
	}
}
</style>
